module.exports = __webpack_public_path__ + "static/TTNBold-6f0a29822159678f3eecd018980bdc30.woff2";